import ExternalDeeplinkScreen from 'features/deeplinks/screens/ExternalDeeplinkScreen/ExternalDeeplinkScreen';
import React from 'react';

const ExternalDeeplinkPage = () => {
  return <ExternalDeeplinkScreen />;
};

export default ExternalDeeplinkPage;
